"use strict";

var _taggedTemplateLiteral = require("/root/icatu-frontend/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject23() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  margin-bottom: 16px;\n"]);

  _templateObject23 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n"]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = _taggedTemplateLiteral(["\n  width: 32px;\n  margin: 0 48px 0 16px;\n\n  div {\n    flex-direction: column;\n    height: 100%;\n  }\n"]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex: ", ";\n  align-items: center;\n"]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n    border-color: ", ";\n  "]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n    border-width: 0 1px 0 0;\n    width: 1px;\n    height: 100%;\n  "]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n    display: none;\n  "]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n  border: 1px ", ";\n  border-spacing: 2px;\n  height: 1px;\n  width: 100%;\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n    border-color: ", ";\n  "]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n    border-color: ", ";\n  "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n    border-color: ", ";\n  "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n    overflow: hidden;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n\n    & > * {\n      position: absolute;\n      left: 50%;\n      top: 50%;\n      transform: translate(-50%, -50%);\n    }\n  "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n    min-width: 32px;\n    min-height: 32px;\n    max-width: 32px;\n    max-height: 32px;\n  "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n    border-color: ", ";\n    background-color: ", ";\n  "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n    border: 2px solid ", ";\n    min-width: 24px;\n    min-height: 24px;\n    max-width: 24px;\n    max-height: 24px;\n  "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  min-width: 10px;\n  min-height: 10px;\n  max-width: 10px;\n  max-height: 10px;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    margin: 16px 0;\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  border: 1px solid;\n  background-color: ", ";\n  margin: 16px;\n  border-radius: 50%;\n  display: block;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    flex-direction: column;\n\n    & > div {\n      flex-direction: column;\n      height: auto;\n    }\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  margin-right: auto;\n  margin-left: auto;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  max-width: 75rem;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    width: 32px;\n    height: auto;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wizardVerticalStepsContainerContent = exports.wizardVerticalStepsContainerWrapper = exports.wizardVerticalStepsContainerAdornment = exports.wizardVerticalStepsContainer = exports.wizardStep = exports.wizardLineCustom = exports.wizardLineLastStep = exports.wizardLineVertical = exports.wizardLine = exports.wizardSuccess = exports.wizardDisabled = exports.wizardActive = exports.wizardBulletWithIcon = exports.wizardBulletLarge = exports.wizardBulletCustom = exports.wizardBulletRegular = exports.wizardBulletSmall = exports.wizardBulletVertical = exports.wizardBullet = exports.wizardContainer = exports.wizardContainerVertical = exports.wizardWrapperVertical = exports.wizardWrapper = void 0;

var _stylitas = require("@creditas/stylitas");

var wizardWrapper = function wizardWrapper() {
  return (0, _stylitas.css)(_templateObject());
};

exports.wizardWrapper = wizardWrapper;

var wizardWrapperVertical = function wizardWrapperVertical(_ref) {
  var direction = _ref.direction;
  return direction === 'vertical' && (0, _stylitas.css)(_templateObject2());
};

exports.wizardWrapperVertical = wizardWrapperVertical;

var wizardContainer = function wizardContainer() {
  return (0, _stylitas.css)(_templateObject3());
};

exports.wizardContainer = wizardContainer;

var wizardContainerVertical = function wizardContainerVertical(_ref2) {
  var direction = _ref2.direction;
  return direction === 'vertical' && (0, _stylitas.css)(_templateObject4());
};

exports.wizardContainerVertical = wizardContainerVertical;

var wizardBullet = function wizardBullet(_ref3) {
  var theme = _ref3.theme;
  return (0, _stylitas.css)(_templateObject5(), _stylitas.utilities.palette.color(theme, 'neutral01'));
};

exports.wizardBullet = wizardBullet;

var wizardBulletVertical = function wizardBulletVertical(_ref4) {
  var direction = _ref4.direction;
  return direction === 'vertical' && (0, _stylitas.css)(_templateObject6());
};

exports.wizardBulletVertical = wizardBulletVertical;

var wizardBulletSmall = function wizardBulletSmall() {
  return (0, _stylitas.css)(_templateObject7());
};

exports.wizardBulletSmall = wizardBulletSmall;

var wizardBulletRegular = function wizardBulletRegular(_ref5) {
  var theme = _ref5.theme,
      variant = _ref5.variant;
  return variant === 'active' && (0, _stylitas.css)(_templateObject8(), _stylitas.utilities.palette.color(theme, 'secondary05'));
};

exports.wizardBulletRegular = wizardBulletRegular;

var wizardBulletCustom = function wizardBulletCustom(_ref6) {
  var theme = _ref6.theme,
      variant = _ref6.variant,
      color = _ref6.color,
      backgroundColor = _ref6.backgroundColor;
  return variant === 'custom' && (0, _stylitas.css)(_templateObject9(), color ? _stylitas.utilities.palette.color(theme, color) : theme.bColorneutral05, backgroundColor ? _stylitas.utilities.palette.color(theme, backgroundColor) : theme.bColorneutral00);
};

exports.wizardBulletCustom = wizardBulletCustom;

var wizardBulletLarge = function wizardBulletLarge(_ref7) {
  var variant = _ref7.variant;
  return variant === 'custom' && (0, _stylitas.css)(_templateObject10());
};

exports.wizardBulletLarge = wizardBulletLarge;

var wizardBulletWithIcon = function wizardBulletWithIcon(_ref8) {
  var icon = _ref8.icon;
  return icon && (0, _stylitas.css)(_templateObject11());
};

exports.wizardBulletWithIcon = wizardBulletWithIcon;

var wizardActive = function wizardActive(_ref9) {
  var theme = _ref9.theme,
      variant = _ref9.variant;
  return variant === 'active' && (0, _stylitas.css)(_templateObject12(), theme.bLabelactionColor);
};

exports.wizardActive = wizardActive;

var wizardDisabled = function wizardDisabled(_ref10) {
  var theme = _ref10.theme,
      variant = _ref10.variant;
  return variant === 'disabled' && (0, _stylitas.css)(_templateObject13(), _stylitas.utilities.palette.color(theme, 'neutral04'));
};

exports.wizardDisabled = wizardDisabled;

var wizardSuccess = function wizardSuccess(_ref11) {
  var theme = _ref11.theme,
      variant = _ref11.variant;
  return variant === 'success' && (0, _stylitas.css)(_templateObject14(), _stylitas.utilities.palette.color(theme, 'success'));
};

exports.wizardSuccess = wizardSuccess;

var wizardLine = function wizardLine(_ref12) {
  var _ref12$lineStyle = _ref12.lineStyle,
      lineStyle = _ref12$lineStyle === void 0 ? 'dashed' : _ref12$lineStyle;
  return (0, _stylitas.css)(_templateObject15(), lineStyle);
};

exports.wizardLine = wizardLine;

var wizardLineLastStep = function wizardLineLastStep(_ref13) {
  var lastStep = _ref13.lastStep;
  return lastStep && (0, _stylitas.css)(_templateObject16());
};

exports.wizardLineLastStep = wizardLineLastStep;

var wizardLineVertical = function wizardLineVertical(_ref14) {
  var direction = _ref14.direction;
  return direction === 'vertical' && (0, _stylitas.css)(_templateObject17());
};

exports.wizardLineVertical = wizardLineVertical;

var wizardLineCustom = function wizardLineCustom(_ref15) {
  var theme = _ref15.theme,
      variant = _ref15.variant,
      color = _ref15.color;
  return variant === 'custom' && (0, _stylitas.css)(_templateObject18(), color ? _stylitas.utilities.palette.color(theme, color) : theme.bColorneutral05);
};

exports.wizardLineCustom = wizardLineCustom;

var wizardStep = function wizardStep(_ref16) {
  var lastStep = _ref16.lastStep;
  return (0, _stylitas.css)(_templateObject19(), lastStep ? 'none' : '1');
};

exports.wizardStep = wizardStep;

var wizardVerticalStepsContainer = function wizardVerticalStepsContainer() {
  return (0, _stylitas.css)(_templateObject20());
};

exports.wizardVerticalStepsContainer = wizardVerticalStepsContainer;

var wizardVerticalStepsContainerAdornment = function wizardVerticalStepsContainerAdornment() {
  return (0, _stylitas.css)(_templateObject21());
};

exports.wizardVerticalStepsContainerAdornment = wizardVerticalStepsContainerAdornment;

var wizardVerticalStepsContainerWrapper = function wizardVerticalStepsContainerWrapper() {
  return (0, _stylitas.css)(_templateObject22());
};

exports.wizardVerticalStepsContainerWrapper = wizardVerticalStepsContainerWrapper;

var wizardVerticalStepsContainerContent = function wizardVerticalStepsContainerContent() {
  return (0, _stylitas.css)(_templateObject23());
};

exports.wizardVerticalStepsContainerContent = wizardVerticalStepsContainerContent;